import { render, staticRenderFns } from "./NewNav.vue?vue&type=template&id=539814be&"
import script from "./NewNav.vue?vue&type=script&lang=js&"
export * from "./NewNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports